<div class="container-fluid p-4">
  <div class="row">
    <div class="row mb-2">
      <div class="col-12">
        <div class="hero-section">
          <div class="hero-content">
            <h2>
              Build Future-Ready Skills in
              <span class="highlight">AI & Emerging Technologies</span>
            </h2>

            <div class="trending-paths">
              <div class="path-label">
                <mat-icon>local_fire_department</mat-icon>
                <span>TRENDING LEARNING PATHS:</span>
              </div>
              <div class="path-tags">
                <span class="path-tag">Artificial Intelligence</span>
                <span class="path-tag">Data Science</span>
                <span class="path-tag">Machine Learning</span>
                <span class="path-tag">Generative AI</span>
                <span class="path-tag">Full Stack Development</span>
                <span class="path-tag">Cloud Computing</span>
                <span class="path-tag">Cybersecurity</span>
                <span class="path-tag">Product & UI/UX Design</span>
              </div>
            </div>
          </div>

          <div class="hero-actions">
            <button
              class="my-learning-btn"
              [routerLink]="['/student-dashboard/my-learning']"
            >
              <mat-icon>menu_book</mat-icon>
              <span>My Learning</span>
              <mat-icon class="arrow-icon">chevron_right</mat-icon>
            </button>
          </div>

          <div class="hero-decoration">
            <div class="circle c1"></div>
            <div class="circle c2"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row font-name">
      <div class="tabs-container mb-1">
        <button
          class="tab"
          [class.active]="selectedTab === proCoursesStatusEnum.ALL_PROGRAM"
          (click)="selectTab(proCoursesStatusEnum.ALL_PROGRAM)"
        >
          <i class="bi bi-grid-1x2-fill"></i>
          All Courses <span class="count-badge">{{ totalCourseCount }}</span>
        </button>
      </div>

      <ng-container *hasPermission="PermissionForStudents.COURSE_VIEW">
        <div
          *ngIf="selectedTab === proCoursesStatusEnum.ALL_PROGRAM"
          class="tab-content"
        >
          <div class="col-12">
            <div class="row">
              <ng-container *ngIf="isLoading; else pageContent">
                <div class="app-spinner">
                  <mat-spinner diameter="60"></mat-spinner>
                </div>
              </ng-container>
              <ng-template #pageContent>
                <ng-container
                  *ngIf="studentCourse.length > 0; else showMessage"
                >
                  <div class="ms-2 course-name">
                    <h2>Explore All Professional Courses</h2>
                  </div>
                  <div
                    class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3"
                    *ngFor="let course of studentCourse"
                  >
                    <div class="card h-100">
                      <div
                        class="card-top"
                        [ngClass]="{ 'no-thumbnail': !course.course_thumbnail }"
                        [ngStyle]="
                          course.course_thumbnail
                            ? {
                                'background-image':
                                  'url(' + course.course_thumbnail + ')',
                              }
                            : {}
                        "
                      ></div>
                      <div class="card-body">
                        <h5
                          class="card-title text-truncate"
                          matTooltip="{{ course.course_title }}"
                        >
                          {{ course.course_title || "N/A" }}
                        </h5>
                        <p
                          class="card-text two-line"
                          matTooltip="{{ course.course_description }}"
                        >
                          {{ course.course_description }}
                        </p>
                        <div class="stats mb-3">
                          <i class="bi bi-people"></i>
                          {{ course.student_count }}
                          <i class="bi bi-star-fill text-warning"></i>
                          {{ course.rating }}
                          <!-- <i class="bi bi-clock"></i> {{ course.course_duration}} will used this later -->
                        </div>
                        <div class="level-seats mb-3">
                          <span class="badge2">{{
                            course.grade_level || "N/A"
                          }}</span>
                        </div>
                        <div class="mini-progress">
                          <div
                            class="mini-progress-bar"
                            [style.width.%]="course.progress_percentage ?? 0"
                          ></div>
                          <span class="mini-progress-text">
                            {{
                              course.progress_percentage ?? 0 | number: "1.0-2"
                            }}%
                          </span>
                        </div>

                        <ng-container
                          *ngIf="
                            course.progress_percentage === 100;
                            else notCompleted
                          "
                        >
                          <button
                            class="btn-add w-100 mt-2 p-2"
                            (click)="goToDetailPage(course.course_id)"
                          >
                            Completed
                            <i class="bi bi-check-circle"></i>
                          </button>
                        </ng-container>

                        <ng-template #notCompleted>
                          <ng-container
                            *ngIf="course.is_enrolled; else showContinueBtn"
                          >
                            <button
                              class="btn-cancel w-100 mt-2 p-2"
                              (click)="
                                goToCourseDescriptionPage(course.course_id)
                              "
                            >
                              Continue Learning
                              <i class="bi bi-arrow-right-circle"></i>
                            </button>
                          </ng-container>
                        </ng-template>
                        <ng-template #showContinueBtn>
                          <button
                            class="btn-add w-100 mt-2"
                            (click)="goToDetailPage(course.course_id)"
                            *hasPermission="PermissionForStudents.COURSE_ENROLL"
                          >
                            Explore
                            <i class="bi bi-arrow-right-circle"></i>
                          </button>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div class="text-center mt-3 font-name" *ngIf="page < totalCoursePages">
                    <button
                      class="btn-add"
                      (click)="loadMore()"
                      [disabled]="isLoading"
                    >
                      <ng-container *ngIf="isLoading; else showBtnText">
                        <span class="spinner-border spinner-border-sm"></span>
                        Loading...
                      </ng-container>
                      <ng-template #showBtnText>Load More</ng-template>
                    </button>
                  </div>
                </ng-container>
                <ng-template #showMessage>
                  <p class="text-center font-name">Courses not found</p>
                </ng-template>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>